__turbopack_context__.v({
  "tab_container": "TabContainer-module-scss-module__GvLkYW__tab_container",
  "tab_panel": "TabContainer-module-scss-module__GvLkYW__tab_panel",
  "tab_sections": "TabContainer-module-scss-module__GvLkYW__tab_sections",
  "tabs": "TabContainer-module-scss-module__GvLkYW__tabs",
});
